import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DownloadAppModalComponent } from '../download-app-modal/download-app-modal.component';
import { Reservation } from '@app/models/micro';
import { GlobalsService } from '@app/services/micro/globals.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApiService } from '@app/services/micro/api.service';
import { combineLatest, take } from 'rxjs';
import { PassengerListStandbyInt } from '@app/interfaces/micro/passengerListStandby.interface';
import { LoadingService } from '@app/services/loading.service';
import { TypeLoading } from '@app/enums';
import {Subscription} from 'rxjs';
import { KioskPermissionsService } from '@services/kiosk-permissions.service';
@Component({
    selector: 'passengers-priority-code',
    templateUrl: './modal-passengers-priority-code.component.html',
    styleUrls: ['./modal-passengers-priority-code.component.scss'],
    standalone: false
})
export class ModalPassengersPriorityCodeComponent implements OnInit {

  activeTab: 'upgrade' | 'standby' = 'upgrade';
  reservation: Reservation;
  optionsForm: FormGroup;
  standByList: PassengerListStandbyInt | any = [];
  upgradeList: PassengerListStandbyInt | any = [];
  passengers = []
  isLoadingStatusPassenger = true;
  subs: Subscription[] = [];
  loadingStatusPassenger = true;
  constructor(
    private _globalService: GlobalsService,
    private _apiService: ApiService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public modal: NgbActiveModal,
    private _loadingService: LoadingService,
    private _kioskPermissions: KioskPermissionsService,
  ) {
    this.optionsForm = this.fb.group({
      option: 'upgrade',
    })
  }

  async ngOnInit() {
    if (!this._kioskPermissions.hasPermission('enabledStbUpgradeListModal')) {
      this.modal.close();
      return;
    }
    this.initLoading();
    this.reservation = this._globalService.getReservation();
    await this.loadStb(this.reservation);
    this.optionsForm.valueChanges.subscribe({
      next: value => (this.getCopies(value, [...this.standByList as any, ...this.upgradeList as any]))
    })
  }

  setActive(tab: 'upgrade' | 'standby') {
    this.activeTab = tab;
  }

  onClose() {
    this.modal.close();
  }

  handleModalApp() {
    const modalRef = this.modalService.open(DownloadAppModalComponent,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        windowClass: 'Premier-modal'
      }
    );
  }

  loadStb(reservation: Reservation) {
    return new Promise((resolve) => {
      combineLatest(
        [
          this._apiService.getPassengerListstandby(reservation),
          this._apiService.getPassengerListUpgrade(reservation)
        ]
      ).pipe(take(1)).subscribe({
        next: ([successListStandby, successUpgradeList]) => {
          if (successListStandby) {
            const standbyPassengers  = successListStandby.passengers ?? []
            if (standbyPassengers.length > 0) {
              standbyPassengers.filter((p) => p.reservationCode == reservation.pnr)
                .map((p) => {
                  p.select = true;
                  return {
                    p
                  }
                });
              this.activeTab = 'standby'

            }
            this.standByList = standbyPassengers || [];
          }
          if (successUpgradeList) {
            const upgradePassengers = successUpgradeList?.passengers ?? []
            if (upgradePassengers.length > 0) {
              upgradePassengers.filter((p) => p.reservationCode == reservation.pnr)
                .map((p) => {
                  p.select = true;
                  return p;
                });
              this.activeTab = 'upgrade'
            }
            this.upgradeList = upgradePassengers || [];
            this.loadingStatusPassenger = false;
            return resolve(true);
          }
        },
        error: error => {
        },
        complete: () => {
          try {
            this.getCopies(this.optionsForm.value, [...this.standByList as any, ...this.upgradeList as any])
          } catch (e) {
            console.error(e)
          }
        }
      })
    })
  }

  getCopies(type, passengersOnList) {
    if (type === 'upgrade') {
      const list = passengersOnList.filter(
        el => (el.reservationCode = this.reservation.pnr &&
          (!el.seat || el.seat === null)
        ))
      return list.length === 0 ? "Upgrades Available" : 'Upgrades Assigned'
    }
    else {
      const list = passengersOnList.filter(
        el => (el.reservationCode = this.reservation.pnr &&
          (!el.seat || el.seat === null)
        ))
      return list.length === 0 ? "Standbt seats Available" : 'Standby seats Assigned'
    }
  }

  initLoading(){
    const subsLoading = this._loadingService.loadings[TypeLoading.COMPONENT_LOADING].loading$.subscribe(loading=>{
      this.isLoadingStatusPassenger = loading;
    });
    this.subs.push(subsLoading);
  }
}
